import { render, staticRenderFns } from "./RelatorioPartida.vue?vue&type=template&id=46520dc6&scoped=true"
import script from "./RelatorioPartida.vue?vue&type=script&lang=js"
export * from "./RelatorioPartida.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPartida.vue?vue&type=style&index=0&id=46520dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46520dc6",
  null
  
)

export default component.exports